<template>
    <div class="painelCinza">
      <b-container fluid >
          <b-row>
                 <b-col align-self="start">
                <h6><b>{{ $t('label.acesso_painel_adm') }}</b></h6>
                 </b-col>
          </b-row>
          <br>
          <br>
          <b-row>
                 <b-col align-self="start" fluid="lg" cols="3" class="tamanhoResponsivo">
                  {{ $t('label.login') }}
                  <b-form-group class="input-label" id="numero">
                      <b-form-input
                            type="text"
                            v-model="login"
                      ></b-form-input>
                  </b-form-group>		
                 </b-col>   		
            </b-row>
          <br>
          <b-row>
              <b-col fluid="lg" cols="3" class="tamanhoResponsivo">
                  {{ $t('label.senha') }}
                  <b-form-group class="input-label">
                    <b-form-input
                          type="password"
                           v-model="senha"
                      ></b-form-input>
                  </b-form-group>			
                 </b-col>
            </b-row>
          <b-row>
              <b-col  fluid="lg" cols="3">
                  <b-button @click="efetuaLogin(login, senha)" variant="primary" size="sm">{{ $t('label.acessar') }}</b-button>
                 </b-col>		
            </b-row> 
      </b-container>
    </div>
  
  </template>
  
  <script>
    import {praca} from '../config.js';
    
    import CartaoModel from '../models/CartaoModel';
    import BaseMixin from '../mixins/BaseMixin';
    import MetodosAuxiliares from "@/helper/MetodosAuxiliares";
    import CartaoService from "@/services/CartaoService";
    import LoginService from "@/services/LoginService";
    import CartaoValidator from "@/models/validator/CartaoValidator";
    import {mapGetters, mapState, mapActions} from 'vuex';
    export default {
        mixins: [BaseMixin],
        data() {
            return {
                cartaoService: new CartaoService(),
                loginService: new LoginService(),
                cartaoValidator: new CartaoValidator(),
                metodosAuxiliares: new MetodosAuxiliares(),
    
                aux: praca,

                login: '',
                senha: '',
            };
        },
    
        created(){
            
            this.configBreadCrumb({
                botoesAcao: {
                    salvar: false,
                    voltar: true
                }
            });
    
        },
    
        computed: {
            ...mapGetters('SolicitacoesStore', ['FiltroSolicitacoes']),
            ...mapState('SolicitacoesStore', ['FiltroSolicitacoes']),
            ...mapGetters('cartaoStore', ['Cartao']),
            ...mapState('cartaoStore', ['Cartao']),
        },
    
        mounted() {
            this.FiltroHomeLocal = Object.assign({}, this.FiltroHome)
            localStorage.setItem('token', '')
        },
        
        methods: {
    
            ...mapActions('cartaoStore', ['updateStateCartao']),

            async efetuaLogin(login, senha) {
                try {
                    this.metodosAuxiliares.IsLoginAdm(login)
                    this.metodosAuxiliares.IsSenhaAdm(senha)
                    this.redirectSolicitacoes()  
                } catch (error) {
                    this.flagValidouOK = false;	
                    this.criaModalMensagem({ titulo: this.$t("label.aviso"), descricao: this.$t(error.message) }, null, null);   
                }

            },

            async redirectSolicitacoes() {
			    this.$router.push({ name: "AdmPainel" });
		    },

        }
    }
</script>
  
  
  